// extracted by mini-css-extract-plugin
module.exports = {"privateTestimonial":"private-testimonial-module--private-testimonial--1-467","imageGridContainer":"private-testimonial-module--image-grid-container--1X3f2"};